import { Controller } from "stimulus";

export default class extends Controller {
  static targets = ["templateField", "previewGroup"];

  update() {
    const template = this._templateValue();

    this.previewGroupTargets.forEach((group) => {
      group.classList.toggle('hidden', group.dataset.statementTemplate !== template);
    });
  }

  _templateValue() {
    return this.templateFieldTarget.querySelector('input[type="hidden"]')?.value;
  }
}
